<div class="flexLayout">
	<table>
		<tr class="tableRow">
			<label>{{ T.LABEL_RUNS | translate }}</label>
			<label>{{ T.LABEL_DURATION | translate }}</label>
			<label>{{ T.LABEL_INTERMISSION | translate }}</label>
		</tr>
		@for (scheduleEntry of schedule(); track scheduleEntry.runId) {
			@let hasIntermission = !!scheduleEntry.intermissionId;
			<tr class="entryRow tableRow">
				<!--VECTOR-->
				<td>
					<sim-session-run-vector [index]="$index" />
					<mat-divider vertical class="separator" />
				</td>

				<!--TIME-->
				<td class="secondary">
					<span>
						{{ scheduleEntry.start | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }} -
						{{ scheduleEntry.end | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
					</span>
					@if (hasIntermission) {
						<mat-icon fontIcon="fa-plus" fontSet="fal" inline class="separator" />
					}
				</td>

				<!--INTERMISSION-->
				<td>
					@if (hasIntermission) {
						<mat-form-field color="accent" subscriptSizing="dynamic">
							<mat-label>
								<mat-icon fontIcon="fa-coffee" fontSet="fad" inline />
								{{ T.LABEL_INTERMISSION | translate }}
							</mat-label>
							<mat-select [value]="scheduleEntry.intermissionDuration">
								@for (intermissionOption of intermissionOptions(); track intermissionOption) {
									<mat-option
										[value]="intermissionOption"
										(onSelectionChange)="changeIntermission($event, scheduleEntry.intermissionId)"
									>
										{{ intermissionOption }} {{ T.LABEL_MINUTES | translate }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
				</td>
			</tr>
		}
	</table>
</div>
